// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Table UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  /* Default Table Background */
  --ezTableBackgroundColor: var(--ezClockerWhite);
  /* Default Table Font */
  --ezTableFontColor: var(--ezFontColor);
  --ezTableFontSize: 12pt;
  --ezTableFontWeight: var(--ezFontWeight);
  --ezTableFontFamily: var(--ezTextFontFamily);
  /* Default Table Border */
  --ezTableBorderColor: var(--ezClockerGray);
  --ezTableBorderSize: 1px;
  --ezTableBorderStyle: solid;
  /* Header Cells */
  --ezTableHeaderCellBackgroundColor: var(--ezClockerNavy);
  --ezTableHeaderCellFontColor: var(--ezClockerWhite);
  --ezTableHeaderCellFontWeight: bold;
}

/* Table Styles */
table.ez-table {
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-spacing: 0;
}

table.ez-table-transparent-full-width {
  width: 100%;
  padding: 2px;
  background-color: transparent;
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-spacing: 0;
}

table.ez-table-full-width {
  width: 100%;
  padding: 2px;
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-spacing: 0;
}

table.ez-table-full-width-transparent {
  width: 100%;
  padding: 2px;
  background-color: transparent;
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-spacing: 0;
}

/* Table Body Styles */
tbody.ez-table-body {
  background-color: var(--ezTableBackgroundColor);
  padding: 2px;
  border-color: var(--ezTableBorderColor);
  border-style: solid;
  border-width: 1px;
}

tr.ez-table-row {
  padding: 0;
  border-style: none;
}

td.ez-table-cell {
  padding: 4px;
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezTableBorderColor);
  border-width: var(--ezTableBorderSize);
  border-style: var(--ezTableBorderStyle);
}

td.ez-table-cell-max-width-50 {
  padding: 4px;
  max-width: 50%;
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezTableBorderColor);
  border-width: var(--ezTableBorderSize);
  border-style: var(--ezTableBorderStyle);
}

td.ez-table-cell-min-width-50 {
  padding: 4px;
  min-width: 50%;
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezTableBorderColor);
  border-width: var(--ezTableBorderSize);
  border-style: var(--ezTableBorderStyle);
}

.ez-cell-align-top-left {
  vertical-align: top;
  text-align: left;
}

.ez-cell-align-middle-center {
  vertical-align: middle;
  text-align: center;
}

.ezTable-cell-align-top-center {
  vertical-align: top;
  text-align: center;
}

.ezTable-cell-align-bottom-center {
  vertical-align: bottom;
  text-align: center;
}

.ez-cell-align-middle-left {
  vertical-align: middle;
  text-align: left;
}

.ez-cell-vertical-align-top {
  vertical-align: top;
}

.ez-cell-vertical-align-bottom {
  vertical-align: bottom;
}

.ez-cell-vertical-align-middle {
  vertical-align: middle;
}

.ez-cell-horizontal-align-left {
  text-align: left;
}

.ez-cell-horizontal-align-center {
  text-align: center;
}

.ez-cell-horizontal-align-right {
  text-align: right;
}

td.ez-cell-width-33 {
  width: 33%;
}

/* Table Header Styles */
thead.ez-sticky-table-header {
  position: sticky;
}

thead.ez-table-header {
  padding: 4px;
  background-color: var(--ezTableHeaderCellBackgroundColor);
  color: var(--ezTableHeaderCellFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
}

th.ezTables-cell-header-silver {
  padding: 4px;
  /* --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* --ezClockerBlack defined in ez-body.css */
  color: var(--ezClockerBlack);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
  font-family: var(--ezTableFontFamily);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

th.ez-table-cell-header {
  padding: 4px;
  background-color: var(--ezTableHeaderCellBackgroundColor);
  color: var(--ezTableHeaderCellFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

th.ez-table-cell-header-left-align {
  padding: 4px;
  background-color: var(--ezTableHeaderCellBackgroundColor);
  color: var(--ezTableHeaderCellFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
  font-family: var(--ezTableFontFamily);
  text-align: left;
  vertical-align: top;
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

th.ez-table-cell-header-fixed {
  padding: 4px;
  position: sticky;
  top: 0;
  background-color: var(--ezTableHeaderCellBackgroundColor);
  color: var(--ezTableHeaderCellFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
}

td.ez-table-cell-width-50 {
  width: 50%;
}

td.ezTable-action-buttons-col {
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: right;
  vertical-align: middle;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-tables.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,6BAAA;EACA,+CAAA;EAEA,uBAAA;EACA,sCAAA;EACA,uBAAA;EACA,wCAAA;EACA,4CAAA;EAEA,yBAAA;EACA,0CAAA;EACA,wBAAA;EACA,2BAAA;EAEA,iBAAA;EACA,wDAAA;EACA,mDAAA;EACA,mCAAA;AAHJ;;AAMA,iBAAA;AACA;EACI,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,iBAAA;AAHJ;;AAMA,sBAAA;AACA;EACI,+CAAA;EACA,YAAA;EACA,uCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,UAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EACA,sCAAA;EACA,uCAAA;AAHJ;;AAMA;EACI,YAAA;EACA,cAAA;EACA,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EACA,sCAAA;EACA,uCAAA;AAHJ;;AAMA;EACI,YAAA;EACA,cAAA;EACA,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EACA,sCAAA;EACA,uCAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,sBAAA;AAHJ;;AAMA;EACI,sBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ;;AAMA,wBAAA;AACA;EACI,gBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,yDAAA;EACA,wCAAA;EACA,iCAAA;EACA,+CAAA;AAHJ;;AAMA;EACI,YAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,4BAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,2CAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,yDAAA;EACA,wCAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,yDAAA;EACA,wCAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,gBAAA;EACA,MAAA;EACA,yDAAA;EACA,wCAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ;;AAMA;EACI,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;AAHJ;;AAMA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Table UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n:root {\n    /* Default Table Background */\n    --ezTableBackgroundColor: var(--ezClockerWhite);\n\n    /* Default Table Font */\n    --ezTableFontColor: var(--ezFontColor);\n    --ezTableFontSize: 12pt;\n    --ezTableFontWeight: var(--ezFontWeight);\n    --ezTableFontFamily: var(--ezTextFontFamily);\n\n    /* Default Table Border */\n    --ezTableBorderColor: var(--ezClockerGray);\n    --ezTableBorderSize: 1px;\n    --ezTableBorderStyle: solid;\n\n    /* Header Cells */\n    --ezTableHeaderCellBackgroundColor: var(--ezClockerNavy);\n    --ezTableHeaderCellFontColor: var(--ezClockerWhite);\n    --ezTableHeaderCellFontWeight: bold;\n}\n\n/* Table Styles */\ntable.ez-table {\n    background-color: var(--ezTableBackgroundColor);\n    color: var(--ezTableFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableFontWeight);\n    font-family: var(--ezTableFontFamily);\n    border-spacing: 0;\n}\n\ntable.ez-table-transparent-full-width {\n    width: 100%;\n    padding: 2px;\n    background-color: transparent;\n    color: var(--ezTableFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableFontWeight);\n    font-family: var(--ezTableFontFamily);\n    border-spacing: 0;\n}\n\ntable.ez-table-full-width {\n    width: 100%;\n    padding: 2px;\n    background-color: var(--ezTableBackgroundColor);\n    color: var(--ezTableFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableFontWeight);\n    font-family: var(--ezTableFontFamily);\n    border-spacing: 0;\n}\n\ntable.ez-table-full-width-transparent {\n    width: 100%;\n    padding: 2px;\n    background-color: transparent;\n    color: var(--ezTableFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableFontWeight);\n    font-family: var(--ezTableFontFamily);\n    border-spacing: 0;\n}\n\n/* Table Body Styles */\ntbody.ez-table-body {\n    background-color: var(--ezTableBackgroundColor);\n    padding: 2px;\n    border-color: var(--ezTableBorderColor);\n    border-style: solid;\n    border-width: 1px;\n}\n\ntr.ez-table-row {\n    padding: 0;\n    border-style: none;\n}\n\ntd.ez-table-cell {\n    padding: 4px;\n    background-color: var(--ezTableBackgroundColor);\n    color: var(--ezTableFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableFontWeight);\n    font-family: var(--ezTableFontFamily);\n    border-color: var(--ezTableBorderColor);\n    border-width: var(--ezTableBorderSize);\n    border-style: var(--ezTableBorderStyle);\n}\n\ntd.ez-table-cell-max-width-50 {\n    padding: 4px;\n    max-width: 50%;\n    background-color: var(--ezTableBackgroundColor);\n    color: var(--ezTableFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableFontWeight);\n    font-family: var(--ezTableFontFamily);\n    border-color: var(--ezTableBorderColor);\n    border-width: var(--ezTableBorderSize);\n    border-style: var(--ezTableBorderStyle);\n}\n\ntd.ez-table-cell-min-width-50 {\n    padding: 4px;\n    min-width: 50%;\n    background-color: var(--ezTableBackgroundColor);\n    color: var(--ezTableFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableFontWeight);\n    font-family: var(--ezTableFontFamily);\n    border-color: var(--ezTableBorderColor);\n    border-width: var(--ezTableBorderSize);\n    border-style: var(--ezTableBorderStyle);\n}\n\n.ez-cell-align-top-left {\n    vertical-align: top;\n    text-align: left;\n}\n\n.ez-cell-align-middle-center {\n    vertical-align: middle;\n    text-align: center;\n}\n\n.ezTable-cell-align-top-center {\n    vertical-align: top;\n    text-align: center;\n}\n\n.ezTable-cell-align-bottom-center {\n    vertical-align: bottom;\n    text-align: center;\n}\n\n.ez-cell-align-middle-left {\n    vertical-align: middle;\n    text-align: left;\n}\n\n.ez-cell-vertical-align-top {\n    vertical-align: top;\n}\n\n.ez-cell-vertical-align-bottom {\n    vertical-align: bottom;\n}\n\n.ez-cell-vertical-align-middle {\n    vertical-align: middle;\n}\n\n.ez-cell-horizontal-align-left {\n    text-align: left;\n}\n\n.ez-cell-horizontal-align-center {\n    text-align: center;\n}\n\n.ez-cell-horizontal-align-right {\n    text-align: right;\n}\n\ntd.ez-cell-width-33 {\n    width: 33%;\n}\n\n/* Table Header Styles */\nthead.ez-sticky-table-header {\n    position: sticky;\n}\n\nthead.ez-table-header {\n    padding: 4px;\n    background-color: var(--ezTableHeaderCellBackgroundColor);\n    color: var(--ezTableHeaderCellFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableHeaderCellFontWeight);\n}\n\nth.ezTables-cell-header-silver {\n    padding: 4px;\n    /* --ezClockerSilver defined in ez-body.css */\n    background-color: var(--ezClockerSilver);\n    /* --ezClockerBlack defined in ez-body.css */\n    color: var(--ezClockerBlack);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableHeaderCellFontWeight);\n    font-family: var(--ezTableFontFamily);\n    /* --ezClockerGray defined in ez-body.css */\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\nth.ez-table-cell-header {\n    padding: 4px;\n    background-color: var(--ezTableHeaderCellBackgroundColor);\n    color: var(--ezTableHeaderCellFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableHeaderCellFontWeight);\n    font-family: var(--ezTableFontFamily);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\nth.ez-table-cell-header-left-align {\n    padding: 4px;\n    background-color: var(--ezTableHeaderCellBackgroundColor);\n    color: var(--ezTableHeaderCellFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableHeaderCellFontWeight);\n    font-family: var(--ezTableFontFamily);\n    text-align: left;\n    vertical-align: top;\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\nth.ez-table-cell-header-fixed {\n    padding: 4px;\n    position: sticky;\n    top: 0;\n    background-color: var(--ezTableHeaderCellBackgroundColor);\n    color: var(--ezTableHeaderCellFontColor);\n    font-size: var(--ezTableFontSize);\n    font-weight: var(--ezTableHeaderCellFontWeight);\n    font-family: var(--ezTableFontFamily);\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n    border-style: solid;\n}\n\ntd.ez-table-cell-width-50 {\n    width: 50%;\n}\n\ntd.ezTable-action-buttons-col {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    text-align: right;\n    vertical-align: middle;\n}\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1023px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 768px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 480px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 319px) {\n}\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
